<template>
  <v-list-item>
    <v-list-item-action title="Aριθμός Παραστατικού" class="pa-0 mr-4">
      <div>
          <v-list-item-action-text># Παρ:</v-list-item-action-text>
        <br>
        <span style="font-size: 0.8em" v-if="dept.StandBy"> Aναμονή</span>
        <span class="">{{ dept.NumberPar }} </span>
      </div>

    </v-list-item-action>
    <v-list-item-content>
      <v-list-item-subtitle>{{ dept.DateInvoice | fullDate }}</v-list-item-subtitle>
      <v-list-item-title v-if="showBranchAddress">{{ dept.BranchAddress }}, {{ dept.BranchAreaName }}
      </v-list-item-title>
      <v-list-item-subtitle v-if="showBrandName">{{ dept.PartnerBrandName }}</v-list-item-subtitle>
      {{ dept.Description }}
      <br/>
      <span style="color:green;" v-if="dept.PendingAmount"> Αναμονή έγκρισης πληρωμής: {{dept.PendingAmount | fixed}} €</span>
    </v-list-item-content>
    <v-list-item-action class="ma-3">
      <div class="text-center faded font-weight-medium pa-1" style="border-radius: 15px;">
        {{ dept.Balance  | fixed }}‎€
      </div>
    </v-list-item-action>
    <slot name="after">
    </slot>
  </v-list-item>
</template>

<script>
import {DeptDetails} from "../../../wl-core/api/classes/DeptDetails";

export default {
  name: "DeptItem",
  props: {dept: DeptDetails, expanded: Boolean, showBrandName: Boolean, showBranchAddress: Boolean}
}
</script>

<style scoped>

</style>
